module.exports = __webpack_public_path__ + "img/location.9a22e77e.webp";